import React, { useEffect, useState } from 'react';
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Modal,
  Paper,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
} from '@mui/material';
import Cancel from './../../../../../assets/icons/close.png';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import AutoCompleteMultiSelect from '../../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';
import TimingComponenet from '../../../../components/TimingComponenet/TimingComponenet.tsx';
import TextAreaComponents from '../../../../components/TextAreaComponents/TextAreaComponents.tsx';
import CreateNewSchedule from './CreateNewSchedule/CreateNewSchedule.tsx';

import previewImg from './../../../../../assets/icons/preview.png';

import scheduleImg from './../../../../../assets/icons/schedule.png';
import SchedularPreviewDialog from './SchedularPreviewDialog/SchedularPreviewDialog.tsx';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FormControlContext from '@mui/material/FormControl/FormControlContext';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Scheduler from '../../../../Scheduler.js';
import SchedulerDetailsTable from '../SchedulerDetailsViewWithTable/SchedulerDetailsTable.tsx';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

function ScheduleItemDialog(props) {
  const handleClose = () => {
    props.onHandleAddItem(false);
  };
  const [Item, setItem] = React.useState([]);
  const [selectedFoodItem, setSelectedFoodItem] = React.useState([]);
  const [selectedSchedule, setselectedSchedule] = React.useState([]);
  const [inventoryData, setinventoryData] = React.useState([]);
  const apiAddress = process.env.REACT_APP_SECRET;
  const [schedulerDatas, setschedulerDatas] = React.useState([]);
  const [schedulerDataFactory, setschedulerDataFactory] = React.useState([]);
  const [itemsSchedulerFromDb, setItemsSchedulerFromDb] = React.useState([]);
  const addValue = (props) => {
    console.log(props);
    setItem(props);
    var ids = props.map((x) => x.id);
    console.log(ids);
    if (props) {
      axios
        .post(
          apiAddress +
            '/api/InventorySetup/GetInventorySchedulerDetailsByContentId',
          ids
        )
        .then((res) => {
          if (res.data.length > 0) {
            console.log('schedulerDataFactory', schedulerDataFactory);
            console.log('res.data', res.data);
            setItemsSchedulerFromDb(res.data);
            setselectedSchedule(
              schedulerDatas.filter((x) =>
                res.data.some((y) => y.scheduleId === x.id)
              )
            );
            // res.data.map((dt) => {
            //   var obj = schedulerDatas.find((x) => x.id == dt.scheduleId);
            //   var contentObj = props.find(
            //     (x) => x.id == dt.inventoryCategoryContentId
            //   );

            //   obj.title = obj.title + " | " + contentObj.title;
            //   obj.contentId = contentObj.id;
            //   var sS = [...selectedSchedule];
            //   var ob = sS.find((x) => x.id == dt.scheduleId);

            //   if (ob) {
            //     ob = { ...ob, title: obj.title };

            //     setselectedSchedule([
            //       ...sS.map((item) => (item.id === ob.id ? ob : item)),
            //     ]);
            //   } else {
            //     setselectedSchedule((prev) => {
            //       const isAlreadyInList = prev.some(
            //         (item) => item.contentId === obj.contentId
            //       );

            //       return isAlreadyInList ? prev : [...prev, obj];
            //     });
            //   }
            // });
          } else {
            // var sS = [...selectedSchedule];
            // schedulerDataFactory.map((dt) => {
            //   var obj = schedulerDatas.find(
            //     (x) => x.title !== dt.title && x.id === dt.id
            //   );
            //   if (obj) {
            //     obj.title = dt.title;
            //   }
            //   var selectedScheduler = sS.find((x) => x.id === dt.id);
            //   if (selectedScheduler) {
            //     selectedScheduler.title = dt.title;
            //   }
            // });
            // setselectedSchedule([...sS]);
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
    } else {
      var sS = [...selectedSchedule];
      setselectedSchedule([]);
      schedulerDataFactory.map((dt) => {
        var obj = schedulerDatas.find(
          (x) => x.title !== dt.title && x.id === dt.id
        );

        if (obj) {
          obj.title = dt.title;
        }

        var selectedScheduler = sS.find((x) => x.id === dt.id);
        if (selectedScheduler) {
          selectedScheduler.title = dt.title;
        }
      });

      setselectedSchedule([...sS]);
    }
    if (props.length > 1 && selectedSchedule.length > 1) {
      setTempSelectedSchedule(selectedSchedule);
      handleTempSchedulerAdd();
      setOpenSchedulerSelectionModal(true);
    }
  };

  const addItemFromSchedulerSelectionModal = (dt) => {
    console.log(dt);
  };

  const addItem = (props) => {
    var ids = [];
    var obj = itemDatas.find((x) => x.title == props);
    if (obj) {
      console.log(obj);
      setSelectedFoodItem(obj);
      ids.push(obj.id);
      axios
        .post(
          apiAddress +
            '/api/InventorySetup/GetInventorySchedulerDetailsByContentId',
          ids
        )
        .then((res) => {
          if (res.data.length > 0) {
            console.log('schedulerDataFactory', schedulerDataFactory);
            console.log('res.data', res.data);
            res.data.map((dt) => {
              var obj = schedulerDatas.find((x) => x.id == dt.scheduleId);
              var contentObj = props.find(
                (x) => x.id == dt.inventoryCategoryContentId
              );

              obj.title = obj.title + ' | ' + contentObj.title;
              obj.contentId = contentObj.id;
              var sS = [...selectedSchedule];
              var ob = sS.find((x) => x.id == dt.scheduleId);

              if (ob) {
                ob = { ...ob, title: obj.title };

                setselectedSchedule([
                  ...sS.map((item) => (item.id === ob.id ? ob : item)),
                ]);
              } else {
                setselectedSchedule((prev) => {
                  const isAlreadyInList = prev.some(
                    (item) => item.contentId === obj.contentId
                  );

                  return isAlreadyInList ? prev : [...prev, obj];
                });
              }
            });
          } else {
            var sS = [...selectedSchedule];
            schedulerDataFactory.map((dt) => {
              var obj = schedulerDatas.find(
                (x) => x.title !== dt.title && x.id === dt.id
              );

              if (obj) {
                obj.title = dt.title;
              }

              var selectedScheduler = sS.find((x) => x.id === dt.id);
              if (selectedScheduler) {
                selectedScheduler.title = dt.title;
              }
            });

            setselectedSchedule([...sS]);
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
    } else {
      var sS = [...selectedSchedule];
      setselectedSchedule([]);
      schedulerDataFactory.map((dt) => {
        var obj = schedulerDatas.find(
          (x) => x.title !== dt.title && x.id === dt.id
        );

        if (obj) {
          obj.title = dt.title;
        }

        var selectedScheduler = sS.find((x) => x.id === dt.id);
        if (selectedScheduler) {
          selectedScheduler.title = dt.title;
        }
      });

      setselectedSchedule([...sS]);
    }
  };
  console.log(schedulerDatas);
  const [checkedSchedules, setCheckedSchedules] = useState([]);

  const [selectedSchedularObj, setselectedSchedularObj] = React.useState([]);
  const [tempselectedSchedule, setTempSelectedSchedule] = React.useState([]);
  const [openSchedulerSelectionModal, setOpenSchedulerSelectionModal] =
    React.useState(false);
  const [
    openSchedulerSelectionChildModal,
    setOpenSchedulerSelectionChildModal,
  ] = React.useState(false);

  const addScheduleValueData = (dt) => {
    if (dt.length > 1 && Item.length > 0) {
      setTempSelectedSchedule(dt);
      handleTempSchedulerAdd();
      setOpenSchedulerSelectionModal(true);
    } else {
      setselectedSchedule(dt);
      setselectedSchedularObj(dt);
    }
  };

  const [value, setValue] = React.useState('SaleHourSchedule');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [ScheduleItem, setScheduleItem] = React.useState([]);
  const [selectedApplyOn, setSelectedApplyOn] = React.useState('');
  const addScheduleValue = (props) => {
    const restaurant = JSON.parse(localStorage.getItem('restaurant'));
    setSelectedApplyOn(props);
    if (props == 'Menu') {
      axios({
        method: 'get',
        url:
          apiAddress +
          '/api/Menu/GetAllMenuIconListByRestaurantIdAsync?restaurantId=' +
          restaurant.id,
      })
        .then(function (response) {
          var temp = [];
          response.data.map((dt, index) => {
            var obj = {
              id: dt.id,
              title: dt.menuName,
              img: dt.iconId,
            };
            temp.push(obj);
          });
          setitemDatas(temp);
        })
        .catch(function (error) {
          console.log(error);
          toast.error(error.response.data, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
        });
    } else if (props == 'Section') {
      axios({
        method: 'get',
        url:
          apiAddress +
          '/api/Section/getallsectionbyrestaurantid?restaurantId=' +
          restaurant.id,
      })
        .then(function (response) {
          var temp = [];
          response.data.map((dt, index) => {
            var obj = {
              id: dt.id,
              title: dt.keywordName,
              img: dt.iconUrl,
            };
            temp.push(obj);
          });
          setitemDatas(temp);
        })
        .catch(function (error) {
          console.log(error);
          toast.error(error.response.data, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
        });
    } else if (props == 'Food Item') {
      axios({
        method: 'get',
        url:
          apiAddress +
          '/api/FoodItems/GetAllFoodItemByRestaurantId?restaurantId=' +
          restaurant.id,
      })
        .then(function (response) {
          var temp = [];
          response.data.map((dt, index) => {
            var obj = {
              id: dt.foodItemId,
              title: dt.itemName,
              img: dt.imgurl,
            };
            temp.push(obj);
          });
          setitemDatas(temp);
        })
        .catch(function (error) {
          console.log(error);
          toast.error(error.response.data, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
        });
    }
  };
  const textFieldValue = (props) => {
    console.log(props);
    // setAutoCompleteValue(props)
  };
  const [itemDatas, setitemDatas] = React.useState([]);
  const sectionDatas = [
    {
      Name: 'Item',
      Items: [
        { id: 1, title: 'Chicken' },
        { id: 2, title: 'Burger' },
        { id: 3, title: 'Curry' },
        { id: 4, title: 'Soup' },
        { id: 5, title: 'Fries' },
      ],
    },
    {
      Name: 'Section',
      Items: [
        { id: 1, title: 'Chicken' },
        { id: 2, title: 'Burger' },
        { id: 3, title: 'Curry' },
        { id: 4, title: 'Soup' },
        { id: 5, title: 'Fries' },
      ],
    },
    {
      Name: 'Menu',
      Items: [
        { id: 1, title: 'In-Store' },
        { id: 2, title: 'Online' },
      ],
    },
  ];
  const scheduleDatas = [
    { id: 1, title: 'Menu' },
    { id: 2, title: 'Section' },
    { id: 3, title: 'Food Item' },
  ];

  const selectedData = (props) => {
    console.log('P: ' + props);
  };
  const saveData = () => {
    props.onHandleAddItem(false);
  };
  const [open, setOpen] = React.useState(false);
  const [previewopen, setpreviewopen] = React.useState(false);
  //dialog start
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleAddItem = (AddItemData) => {
    setOpen(AddItemData);
    loadData();
  };
  const handlePreview = (AddItemData) => {
    setpreviewopen(AddItemData);
  };
  const [quantity, setquantity] = React.useState(0);

  const loadData = async () => {
    axios({
      method: 'get',
      url: apiAddress + '/api/Schedule',
    })
      .then(function (response) {
        var temp = [];
        response.data.map((dt, index) => {
          var obj = {
            id: dt.scheduleId,
            title: dt.scheduleName,
            contentId: null,
          };
          temp.push(obj);
        });
        setschedulerDatas([...temp]);
        setschedulerDataFactory(JSON.parse(JSON.stringify(temp)));
      })
      .catch(function (error) {
        console.log(error);
        toast.error(error.response.data, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
        });
      });
  };
  const [addedSchedulers, setAddedSchedulers] = React.useState([]);
  const [conflictedSchedulers, setConflictedSchedulers] = React.useState([]);
  const [addedtempSchedulers, setaddedtempSchedulers] = React.useState([]);
  const [conflictedTempSchedulers, setConflictedTempSchedulers] =
    React.useState([]);
  useEffect(() => {
    loadData();
    setAddedSchedulers([]);
    setCheckedSchedules([]);
    setselectedSchedule([]);
    setConflictedSchedulers([]);
  }, []);
  console.log(addedSchedulers)

  const calculateDateDifference = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return 0;
    }

    const diffInMs = Math.abs(end - start);

    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

    return diffInDays;
  };

  const handleAdd = async () => {
    setAddedSchedulers([]);
    const ids = selectedSchedule.map((item) => item.id);
    await axios
      .post(apiAddress + '/api/Schedule/getschedulebyidlist', ids)
      .then(function (response) {
        console.log(response.data.schedulerDatas);
        setAddedSchedulers(response.data.schedulerDatas);
        setConflictedSchedulers(response.data.conflictedData);
      })
      .catch(function (error) {
        console.log(error);
        toast.error(error.response.data, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
        });
      });
  };
  const handleTempSchedulerAdd = async () => {
    setaddedtempSchedulers([]);
    const ids = tempselectedSchedule.map((item) => item.id);
    await axios
      .post(apiAddress + '/api/Schedule/getschedulebyidlist', ids)
      .then(function (response) {
        console.log(response.data.schedulerDatas);
        setaddedtempSchedulers(response.data.schedulerDatas);
        setConflictedTempSchedulers(response.data.conflictedData);
      })
      .catch(function (error) {
        console.log(error);
        toast.error(error.response.data, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'colored',
        });
      });
  };
  const checkSchedulerConflicts = (scheduler, conflictedSchedulers) => {
    var res = conflictedSchedulers.some(
      (conflicted) =>
        conflicted.hasConflict &&
        conflicted.remarks.includes(scheduler.scheduleId)
    );
    console.log(res);
    return conflictedSchedulers.some(
      (conflicted) =>
        conflicted.hasConflict &&
        conflicted.remarks.includes(scheduler.scheduleId)
    );
  };

  useEffect(() => {
    handleAdd();
  }, [selectedSchedule]);

  // const handleSave = () => {
  //   const restaurant = JSON.parse(localStorage.getItem('restaurant'));
  //   var list = [];
  //   console.log(selectedApplyOn);
  //   if (selectedApplyOn == 'Food Item') {
  //     console.log(selectedSchedule);
  //     selectedSchedule.map((sc) => {
  //       var obj = {
  //         salesHourSetupId: 'string',
  //         scheduleId: sc?.id,
  //         inventoryCategoryTypeId: 3,
  //         inventoryCategoryContentId: selectedFoodItem.id,
  //         descriedDailyItem: true,
  //         restaurantId: restaurant.id,
  //         creationId: 'string',
  //       };
  //       list.push(obj);
  //       console.log(obj);
  //     });
  //   } else {
  //     if (Item) {
  //       Item.map((dt) => {
  //         var objScheduler = selectedSchedule.find((x) => x.contentId == dt.id);
  //         if (objScheduler) {
  //           var obj = {
  //             salesHourSetupId: 'string',
  //             scheduleId: objScheduler?.id,
  //             inventoryCategoryTypeId:
  //               selectedApplyOn == 'Menu'
  //                 ? 1
  //                 : selectedApplyOn == 'Section'
  //                 ? 2
  //                 : 3,
  //             inventoryCategoryContentId: objScheduler.contentId,
  //             descriedDailyItem: true,
  //             restaurantId: restaurant.id,
  //             creationId: 'string',
  //           };
  //           list.push(obj);
  //         } else {
  //           selectedSchedule.map((sc) => {
  //             var obj = {
  //               salesHourSetupId: 'string',
  //               scheduleId: sc?.id,
  //               inventoryCategoryTypeId:
  //                 selectedApplyOn == 'Menu'
  //                   ? 1
  //                   : selectedApplyOn == 'Section'
  //                   ? 2
  //                   : 3,
  //               inventoryCategoryContentId: sc.contentId,
  //               descriedDailyItem: true,
  //               restaurantId: restaurant.id,
  //               creationId: 'string',
  //             };
  //             list.push(obj);
  //           });
  //         }
  //       });
  //     }
  //   }
  //   if (list.length > 0) {
  //     axios
  //       .post(
  //         apiAddress + '/api/InventorySetup/inventoryCategoryContentId',
  //         list
  //       )
  //       .then((res) => {
  //         toast.success('Sale Hour scheduler save successfully');
  //         saveInventory(res.data[0].salesHourSetupId, res.data[0].scheduleId);

  //         handleClear();
  //       })
  //       .catch((err) => {});
  //   }
  //   console.log(list);
  // };

  // const saveInventory = (id,scheduleId) => {
  //   var obj = inventoryData;
  //   console.log(obj)
  //   obj.salesHourSetupId = id;
  //   obj.SchedulerId=scheduleId;

  //   if (obj){
  //   axios
  //     .post(
  //       apiAddress + '/api/InventorySetup/InsertIntoInventoryScheduler',
  //       obj
  //     )
  //     .then((res) => {
  //       console.warn('OK');
  //     })
  //     .catch((err) => {});
  //   }
  // };
  // const handleInventorySave = (data) => {
  //   setinventoryData(data);
  //   alert(data);
  //   handleSave();
  // };


const handleSave = () => {
  const restaurant = JSON.parse(localStorage.getItem('restaurant'));
  let list = [];
  console.log(selectedApplyOn);

  if (selectedApplyOn === 'Food Item') {
    console.log(selectedSchedule);
    selectedSchedule.forEach((sc) => {
      let obj = {
        salesHourSetupId: 'string',
        scheduleId: sc?.id,
        inventoryCategoryTypeId: 3,
        inventoryCategoryContentId: selectedFoodItem.id,
        descriedDailyItem: true,
        restaurantId: restaurant.id,
        creationId: 'string',
      };
      list.push(obj);
      console.log(obj);
    });
  } else {
    if (Item) {
      Item.forEach((dt) => {
        const objScheduler = selectedSchedule.find((x) => x.contentId === dt.id);
        if (objScheduler) {
          let obj = {
            salesHourSetupId: 'string',
            scheduleId: objScheduler?.id,
            inventoryCategoryTypeId:
              selectedApplyOn === 'Menu'
                ? 1
                : selectedApplyOn === 'Section'
                ? 2
                : 3,
            inventoryCategoryContentId: objScheduler.contentId,
            descriedDailyItem: true,
            restaurantId: restaurant.id,
            creationId: 'string',
          };
          list.push(obj);
        } else {
          selectedSchedule.forEach((sc) => {
            let obj = {
              salesHourSetupId: 'string',
              scheduleId: sc?.id,
              inventoryCategoryTypeId:
                selectedApplyOn === 'Menu'
                  ? 1
                  : selectedApplyOn === 'Section'
                  ? 2
                  : 3,
              inventoryCategoryContentId: sc.contentId,
              descriedDailyItem: true,
              restaurantId: restaurant.id,
              creationId: 'string',
            };
            list.push(obj);
          });
        }
      });
    }
  }

  if (list.length > 0) {
    axios
      .post(apiAddress + '/api/InventorySetup/inventoryCategoryContentId', list)
      .then((res) => {
        toast.success('Sale Hour scheduler saved successfully');
        saveInventory(res.data[0].salesHourSetupId, res.data[0].scheduleId);
        handleClear();
      })
      .catch((err) => {
        console.error(err);
      });
  }
  console.log(list);
};

const saveInventory = (id, scheduleId) => {

  if (inventoryData) {
    const updatedInventoryData = {
      ...inventoryData,
      salesHourSetupId: id,
      SchedulerId: scheduleId,
    };

    console.log(updatedInventoryData)
    axios
      .post(apiAddress + '/api/InventorySetup/InsertIntoInventoryScheduler', updatedInventoryData)
      .then((res) => {
        console.warn('OK');
      })
      .catch((err) => {
        console.error(err);
      });
   }
};
console.log(inventoryData)
useEffect(() => {
  if (inventoryData) {
    handleSave();
  }
}, [inventoryData]);

const handleInventorySave = (data) => {
  setinventoryData(data);
  alert(data);
  console.log(data)
};



  const [savedValues, setSavedValues] = useState([]); // State to store the array of values

  // const handleValueChange = (index, newValue, contentId) => {
  //   const updatedValues = [...savedValues];
  //   updatedValues[index] = newValue;
  //   updatedValues[index].contentId = contentId;
  //   setSavedValues(updatedValues);
  // };

  const handleValueChange = (id, newValue, contentId) => {
    const updatedValues = [...savedValues];

    const index = updatedValues.findIndex(
      (item) => item.contentId === contentId
    );

    if (index !== -1) {
      updatedValues[index] = {
        ...updatedValues[index],
        ...newValue,
        contentId,
      };
    } else {
      updatedValues.push({ ...newValue, contentId });
    }

    setSavedValues(updatedValues);
  };
  useEffect(() => {
    Item.map((dt, i) => {
      var obj = tempselectedSchedule.find((x) =>
        itemsSchedulerFromDb.some(
          (item) =>
            item.scheduleId === x?.id &&
            item.inventoryCategoryContentId === dt.id
        )
      );
      handleValueChange(i, obj, dt.id);
    });
  }, [tempselectedSchedule]);

  const handleTempSave = () => {
    setselectedSchedule(savedValues);
    setOpenSchedulerSelectionModal(false);
  };

  const handleClear = () => {
    setSavedValues([]);
    setselectedSchedule([]);
    setItem([]);
    setSelectedApplyOn('');
  };
  return (
    <div>
      <ToastContainer />
      <React.Fragment>
        <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          open={props.open}
          onClose={handleClose}
        >
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>
                <div className='d-flex' style={{ gap: '8px' }}>
                  <div>
                    <img src={scheduleImg} style={{ width: '1.8rem' }} />
                  </div>

                  <span style={{ color: '#2a7fd4' }}>
                    GoTaste :- Setup Scheduler
                  </span>
                </div>
              </DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={handleClose}>
                  <img src={Cancel} alt='Close' style={{ width: '1.2rem' }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
            <Grid container>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: '1rem' }}>
                  Apply Schedule on
                </Typography>
              </Grid>
              <Grid item xs={10} style={{ paddingTop: '1rem' }}>
                <AutoCompleteMultiSelect
                  label={'Apply on Food Item/ Menu/ Section/ SubSection'}
                  placeholder={'Apply on Food Item/ Menu/ Section/ SubSection'}
                  value={addScheduleValue}
                  datas={scheduleDatas}
                  val={selectedApplyOn}
                  id={1}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: '1rem' }}>
                  Item Name
                </Typography>
              </Grid>
              <Grid item xs={10} style={{ paddingTop: '1rem' }}>
                {selectedApplyOn === 'Food Item' ? (
                  <AutoCompleteMultiSelect
                    label={'Item Name'}
                    placeholder={'Item Name'}
                    value={addItem}
                    datas={itemDatas}
                    id={1}
                  />
                ) : (
                  <Grid item xs={10} style={{ paddingTop: '1rem' }}>
                    <AutoCompleteMultiSelect
                      label={'Item Name'}
                      placeholder={'Item Name'}
                      value={addValue}
                      datas={itemDatas}
                      val={Item}
                      id={2}
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>

            <Box sx={{ width: '100%', marginTop: '1rem' }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label='wrapped label tabs example'
              >
                <Tab value='SaleHourSchedule' label='Sale Hour Schedule' />
                {selectedApplyOn == 'Food Item' && (
                  <Tab value='InventoryScheduler' label='Inventory Scheduler' />
                )}
              </Tabs>
            </Box>
            {value == 'SaleHourSchedule' && (
              <>
                <Grid container>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: '1rem' }}>
                      Select Schedule
                    </Typography>
                  </Grid>
                  <Grid item xs={7} style={{ paddingTop: '1rem' }}>
                    <AutoCompleteMultiSelect
                      label={'Schedule'}
                      placeholder={'Schedule'}
                      value={addScheduleValueData}
                      datas={schedulerDatas}
                      val={selectedSchedule}
                      id={2}
                    />
                    {/* For Conflict Checking */}

                    {/* <span style={{ color: "red" }}>
                      {conflictedSchedulers.length > 0 && (
                        <>Some schedulers have conflicts</>
                      )}
                    </span> */}
                  </Grid>

                  <Grid item xs={2} style={{ paddingTop: '1rem' }}>
                    <button
                      className='btn '
                      style={{ color: 'blue', fontSize: '1.2rem' }}
                      onClick={() => {
                        setOpen(true);
                      }}
                    >
                      {' '}
                      +Create New Schedule
                    </button>
                  </Grid>
                </Grid>
                {/* <div
                  className="d-flex "
                  style={{ justifyContent: "end", marginTop: "1rem" }}
                >
                  <Button
                    variant="outlined"
                    color="success"
                    onClick={() => {
                      handleAdd();
                    }}
                  >
                    Add
                  </Button>
                </div> */}
                {addedSchedulers?.length > 0 && (
                  <SchedulerDetailsTable
                    addedtempSchedulers={addedSchedulers}
                  />
                )}
              </>
            )}
            {value == 'InventoryScheduler' &&
              selectedApplyOn == 'Food Item' && (
                <>
                  <Grid container>
                    <Grid item xs={2}>
                      <Typography style={{ paddingTop: '1rem' }}>
                        Sale Hour Schedule
                      </Typography>
                    </Grid>
                    <Grid item xs={10} style={{ paddingTop: '1rem' }}>
                      <AutoCompleteMultiSelect
                        label={'Schedule'}
                        placeholder={'Schedule'}
                        value={addScheduleValueData}
                        datas={schedulerDatas}
                        val={selectedSchedule}
                        id={2}
                      />
                      <span style={{ color: 'red' }}>
                        {conflictedSchedulers.length > 0 && (
                          <>Some schedulers have conflicts</>
                        )}
                      </span>
                    </Grid>
                  </Grid>

                  <Scheduler
                    addedSchedulers={addedSchedulers}
                    handleClose={handleClose}
                    selectedFoodItem={selectedFoodItem}
                    handleInventorySave={handleInventorySave}
                    selectedSchedule={selectedSchedule}
                  />
                </>
              )}
            <div
              className='justify-content-end'
              style={{
                display: selectedApplyOn === 'Food Item' ? 'none' : 'flex',
              }}
            >
              <Button className='mt-2' color='error' onClick={handleClose}>
                Close
              </Button>
              <Button
                className='mt-2'
                color='success'
                // disabled={conflictedSchedulers.length > 0}
                onClick={handleSave}
              >
                Save
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <CreateNewSchedule
        open={open}
        onHandleAddItem={handleAddItem}
        title={props.title}
      />

      {previewopen ? (
        selectedSchedularObj.length > 0 ? (
          <SchedularPreviewDialog
            open={previewopen}
            onHandleAddItem={handlePreview}
            title={props.title}
            selectedTitle={selectedSchedule}
            selectedId={selectedSchedularObj}
            key={selectedSchedularObj}
          />
        ) : (
          ''
        )
      ) : (
        ''
      )}
      <Modal
        open={openSchedulerSelectionModal}
        onClose={() => setOpenSchedulerSelectionModal(false)}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <div className='d-flex' style={{ justifyContent: 'space-between' }}>
            <Typography variant='h6' component='h1'>
              <strong>Select Schedule</strong>
            </Typography>
            <CloseIcon
              style={{ cursor: 'pointer' }}
              onClick={() => setOpenSchedulerSelectionModal(false)}
            />
          </div>
          {Item.map((dt, i) => {
            return (
              <div
                className='d-flex mt-4'
                style={{
                  width: '100%',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '10px',
                }}
                key={i}
              >
                <div style={{ width: '48%' }}>
                  <AutoCompleteMultiSelect
                    label={'Item Name'}
                    placeholder={'Item Name'}
                    value={(e) => {
                      toast.error('Can not select multiple ' + selectedApplyOn);
                    }}
                    datas={Item.filter((x) => x.id == dt.id)}
                    val={dt}
                    id={33}
                  />
                </div>
                <div
                  className='d-flex'
                  style={{ width: '50%', gap: '10px', alignItems: 'center' }}
                >
                  <div style={{ width: '80%' }}>
                    <AutoCompleteMultiSelect
                      label={'Scheduler'}
                      placeholder={'Scheduler'}
                      value={(selectedValue) => {
                        handleValueChange(i, selectedValue, dt.id); // Update the state with the selected value
                      }}
                      datas={tempselectedSchedule}
                      val={tempselectedSchedule.find((x) =>
                        itemsSchedulerFromDb.some(
                          (item) =>
                            item.scheduleId === x?.id &&
                            item.inventoryCategoryContentId === dt.id
                        )
                      )}
                      id={33}
                    />
                  </div>

                  <div>
                    <img
                      src={previewImg}
                      style={{ width: '2rem' }}
                      onClick={() => {
                        setOpenSchedulerSelectionChildModal(true);
                      }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
          <div className='d-flex w-100 mt-3' style={{ justifyContent: 'end' }}>
            <Button
              color='error'
              onClick={() => setOpenSchedulerSelectionModal(false)}
            >
              Close
            </Button>
            <Button color='success' onClick={handleTempSave}>
              Save
            </Button>
          </div>
        </Box>
      </Modal>
      {openSchedulerSelectionChildModal && (
        <Modal
          open={openSchedulerSelectionChildModal}
          onClose={() => setOpenSchedulerSelectionChildModal(false)}
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
        >
          <Box sx={style}>
            <div className='d-flex' style={{ justifyContent: 'space-between' }}>
              <Typography variant='h6' component='h1'>
                <strong>Scheduler Details</strong>
              </Typography>
              <CloseIcon
                style={{ cursor: 'pointer' }}
                onClick={() => setOpenSchedulerSelectionChildModal(false)}
              />
            </div>
            {addedtempSchedulers?.length > 0 && (
              <SchedulerDetailsTable
                addedtempSchedulers={addedtempSchedulers}
              />
            )}

            <div
              className='d-flex w-100 mt-3'
              style={{ justifyContent: 'end' }}
            >
              <Button
                color='error'
                onClick={() => {
                  setOpenSchedulerSelectionChildModal(false);
                }}
              >
                Close
              </Button>
            </div>
          </Box>
        </Modal>
      )}
    </div>
  );
}

export default ScheduleItemDialog;
